 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~e2e93592": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~e2e93592": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons~31ecd969":"chunk-commons~31ecd969","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~8becc859":"chunk-commons~8becc859","chunk-commons~447143dd":"chunk-commons~447143dd","chunk-commons~a518584b":"chunk-commons~a518584b","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~1029e318":"wonder~1029e318","wonder~76cf4113":"wonder~76cf4113","wonder~4b1f93e4":"wonder~4b1f93e4","download~ff6bbd3c":"download~ff6bbd3c"}[chunkId]||chunkId) + "." + {"chunk-01777e79":"dd2b9fa8","chunk-058516b8":"8b42d299","chunk-05a29214":"66a05f79","chunk-0817f351":"32bf83ff","chunk-12f0034d":"af18da5a","chunk-18c7ccb6":"ef325a59","chunk-197d25cc":"5e51dc33","chunk-1c6faaaa":"6693275d","chunk-266544bb":"4d76148c","chunk-2d0aab45":"8e19cc48","chunk-2d0cc1d9":"5878bb54","chunk-2e63e8a8":"8db75574","chunk-396e857c":"d6d423c2","chunk-403ae9e2":"9e3e11de","chunk-5bb295e6":"327104e0","chunk-63b077ea":"c2c72d7c","chunk-7326328d":"7c1e9d8e","chunk-75fa76d9":"f2f42003","chunk-76ab195d":"03da650d","chunk-7aa1d62d":"ba58d8e8","chunk-7fa4663c":"4c57345b","chunk-8bcb87fc":"ed6fb231","chunk-9bafd256":"afbad789","chunk-commons~31ecd969":"59e8f086","chunk-commons~21833f8f":"007d371d","chunk-commons~8becc859":"dceb0b87","chunk-commons~447143dd":"6f9b98a1","chunk-commons~a518584b":"a22b6fc3","chunk-004b178a":"6ae33e6b","chunk-0affe0e8":"1b11e974","chunk-19447ea9":"9d96f42c","chunk-26e960d6":"69c4949c","chunk-278f15c2":"f5f6d847","chunk-27deee34":"94e5d7ff","chunk-27f3fd22":"68de694b","chunk-2d0a30ec":"839f1d67","chunk-2d0c917a":"554c2173","chunk-2d0da362":"98ccb473","chunk-2d0daf52":"2fc8ed08","chunk-2d0e4810":"16466bb3","chunk-2d0efccf":"26fc44fd","chunk-2d207d1a":"3d1cb5c1","chunk-2d2140d8":"e1be5f21","chunk-2d217776":"11599d08","chunk-2d226c7a":"37ffc864","chunk-304e1d6c":"285f47a8","chunk-3472d4ae":"e7b287c1","chunk-37def2f8":"098d80b3","chunk-4f3f1abe":"60de79ff","chunk-4f6af284":"db354917","chunk-512cb880":"dc624876","chunk-52238220":"8ac7a01b","chunk-5444d5d0":"e7a42591","chunk-561e09c0":"4a726fc5","chunk-57532ed8":"4a626212","chunk-5b3def1e":"12ee2616","chunk-6f4c19ac":"03baa09f","chunk-6fb8840c":"200e606b","chunk-7ad6747e":"3ec36762","chunk-7db9ca4d":"dd3d3491","chunk-7ed5357e":"73fe666e","chunk-c5857f50":"c118a9ad","chunk-d5aa9318":"16a2da29","chunk-fbc5993c":"308d5e64","home~21833f8f":"7f54cdc5","sentiment~21833f8f":"70be8e6c","user~6e76d53f":"b5b431e7","wonder~1029e318":"27d5419b","wonder~76cf4113":"36d0dd3b","wonder~4b1f93e4":"62772733","download~ff6bbd3c":"5f0a7892","chunk-0d6dee76":"3895c8e7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01777e79":1,"chunk-058516b8":1,"chunk-05a29214":1,"chunk-0817f351":1,"chunk-12f0034d":1,"chunk-18c7ccb6":1,"chunk-197d25cc":1,"chunk-1c6faaaa":1,"chunk-266544bb":1,"chunk-396e857c":1,"chunk-5bb295e6":1,"chunk-63b077ea":1,"chunk-7326328d":1,"chunk-75fa76d9":1,"chunk-76ab195d":1,"chunk-7aa1d62d":1,"chunk-7fa4663c":1,"chunk-8bcb87fc":1,"chunk-9bafd256":1,"chunk-commons~21833f8f":1,"chunk-commons~8becc859":1,"chunk-commons~447143dd":1,"chunk-commons~a518584b":1,"chunk-004b178a":1,"chunk-0affe0e8":1,"chunk-19447ea9":1,"chunk-26e960d6":1,"chunk-278f15c2":1,"chunk-27deee34":1,"chunk-27f3fd22":1,"chunk-304e1d6c":1,"chunk-3472d4ae":1,"chunk-37def2f8":1,"chunk-4f3f1abe":1,"chunk-4f6af284":1,"chunk-512cb880":1,"chunk-52238220":1,"chunk-5444d5d0":1,"chunk-561e09c0":1,"chunk-57532ed8":1,"chunk-5b3def1e":1,"chunk-6f4c19ac":1,"chunk-6fb8840c":1,"chunk-7ad6747e":1,"chunk-7db9ca4d":1,"chunk-7ed5357e":1,"chunk-c5857f50":1,"chunk-d5aa9318":1,"chunk-fbc5993c":1,"home~21833f8f":1,"sentiment~21833f8f":1,"user~6e76d53f":1,"wonder~1029e318":1,"wonder~76cf4113":1,"wonder~4b1f93e4":1,"download~ff6bbd3c":1,"chunk-0d6dee76":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons~31ecd969":"chunk-commons~31ecd969","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~8becc859":"chunk-commons~8becc859","chunk-commons~447143dd":"chunk-commons~447143dd","chunk-commons~a518584b":"chunk-commons~a518584b","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~1029e318":"wonder~1029e318","wonder~76cf4113":"wonder~76cf4113","wonder~4b1f93e4":"wonder~4b1f93e4","download~ff6bbd3c":"download~ff6bbd3c"}[chunkId]||chunkId) + "." + {"chunk-01777e79":"f96e9b7e","chunk-058516b8":"0fe3e47d","chunk-05a29214":"20d2b46c","chunk-0817f351":"3a86a2cb","chunk-12f0034d":"80994280","chunk-18c7ccb6":"89d3c8dd","chunk-197d25cc":"38d766f6","chunk-1c6faaaa":"aa86e70a","chunk-266544bb":"2f2e42d6","chunk-2d0aab45":"31d6cfe0","chunk-2d0cc1d9":"31d6cfe0","chunk-2e63e8a8":"31d6cfe0","chunk-396e857c":"9f938ec4","chunk-403ae9e2":"31d6cfe0","chunk-5bb295e6":"064cab12","chunk-63b077ea":"1c1c5ec4","chunk-7326328d":"782f606e","chunk-75fa76d9":"f1a86e88","chunk-76ab195d":"6b43a136","chunk-7aa1d62d":"fb53adac","chunk-7fa4663c":"1a48317d","chunk-8bcb87fc":"f706b72f","chunk-9bafd256":"2bdbdc99","chunk-commons~31ecd969":"31d6cfe0","chunk-commons~21833f8f":"c5536065","chunk-commons~8becc859":"b0ce4262","chunk-commons~447143dd":"c282b7a7","chunk-commons~a518584b":"2aa43edc","chunk-004b178a":"1463a986","chunk-0affe0e8":"8d285cd7","chunk-19447ea9":"45d5b894","chunk-26e960d6":"2ad79ed9","chunk-278f15c2":"5f744cf2","chunk-27deee34":"f9f3b037","chunk-27f3fd22":"bbb495ab","chunk-2d0a30ec":"31d6cfe0","chunk-2d0c917a":"31d6cfe0","chunk-2d0da362":"31d6cfe0","chunk-2d0daf52":"31d6cfe0","chunk-2d0e4810":"31d6cfe0","chunk-2d0efccf":"31d6cfe0","chunk-2d207d1a":"31d6cfe0","chunk-2d2140d8":"31d6cfe0","chunk-2d217776":"31d6cfe0","chunk-2d226c7a":"31d6cfe0","chunk-304e1d6c":"8cdb7431","chunk-3472d4ae":"3e1f1643","chunk-37def2f8":"b5dec195","chunk-4f3f1abe":"5723160d","chunk-4f6af284":"aca056f9","chunk-512cb880":"94b88694","chunk-52238220":"db6e4972","chunk-5444d5d0":"fb9fd7f3","chunk-561e09c0":"3f1f1b9b","chunk-57532ed8":"aa007b25","chunk-5b3def1e":"f8757f53","chunk-6f4c19ac":"78718bd2","chunk-6fb8840c":"652d2237","chunk-7ad6747e":"8afe51c6","chunk-7db9ca4d":"d2558648","chunk-7ed5357e":"38f83a95","chunk-c5857f50":"a3cf1c60","chunk-d5aa9318":"d2116bad","chunk-fbc5993c":"519a0c39","home~21833f8f":"7ff3787a","sentiment~21833f8f":"e780f570","user~6e76d53f":"fb6a60c6","wonder~1029e318":"74058f1e","wonder~76cf4113":"c8ae1625","wonder~4b1f93e4":"768aa46a","download~ff6bbd3c":"8731fe7a","chunk-0d6dee76":"36396c91"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~d939e436"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
